import React from 'react';
import {
  PAYMENT_STATUS_COLORS,
  getPaymentStatusLabel,
} from '../../lib/paymentStatus';

const PaymentStatusBadge = ({ value, locale = 'en' }) => {
  if (value === undefined || value === null) return null;
  const colors = PAYMENT_STATUS_COLORS[value];
  const label = getPaymentStatusLabel(value, locale);
  if (!colors || !label) return null;

  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 10px',
        borderRadius: '999px',
        fontSize: '12px',
        fontWeight: 500,
        background: colors.bg,
        color: colors.fg,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </span>
  );
};

export default PaymentStatusBadge;
